module.exports = __webpack_public_path__ + "img/product-user.b8a90a17.jpg";